export default "__VITE_ASSET__Cg3Y6h1Z__"